import { Partner } from 'src/pages/Partner'

export default Partner
